import { render, staticRenderFns } from "./AttendancesCrud.vue?vue&type=template&id=5dd5bd56"
import script from "./AttendancesCrud.vue?vue&type=script&lang=js"
export * from "./AttendancesCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports